import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { founder, stats } from '../data/mock';
import { Button } from '../components/ui/button';

const AboutPage = () => {
  return (
    <div className="bg-white pt-16 lg:pt-20">
      {/* Hero Section - Dark */}
      <section className="relative py-20 lg:py-28 bg-zinc-900 overflow-hidden">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            // backgroundImage: `url('https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg?w=1920')`,
            backgroundImage: `url('/images/Wallpaper/4.0.jpg')`,
          }}
        />

        {/* Orange accent */}
        <div className="absolute left-0 top-0 bottom-0 w-1 lg:w-2 bg-orange-500" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-0.5 bg-orange-500" />
              <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">About Us</span>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight leading-[0.9] mb-6">
              The Crew
            </h1>
            <p className="text-xl text-zinc-300 leading-relaxed">
              Who we are, where we came from, and why we do this work.
            </p>
          </div>
        </div>
      </section>

      {/* Founder Section - Light */}
      <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          
          {/* Image Column */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="aspect-[3/4] overflow-hidden border-4 border-zinc-100 shadow-lg">
                <img
                  src={founder.image}
                  alt={founder.name}
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Orange corner accent */}
              <div className="absolute -bottom-3 -right-3 w-24 h-24 border-r-4 border-b-4 border-orange-500" />
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-12 h-0.5 bg-orange-500" />
              <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">Meet the Founder</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-black text-zinc-900 uppercase tracking-tight mb-2">
              {founder.name}
            </h2>
            <p className="text-orange-500 font-bold uppercase tracking-wide text-sm mb-8">
              {founder.title}
            </p>
            
            <div className="space-y-6 mb-10">
              {founder.story.map((paragraph, index) => (
                <p 
                  key={index} 
                  className={`text-zinc-600 leading-relaxed text-base lg:text-lg`}
                >
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Values Box */}
            <div className="border-l-4 border-orange-500 pl-6 bg-zinc-50 py-6 pr-6">
              <p className="text-zinc-900 font-black uppercase text-sm tracking-wide mb-4">
                Our Services:
              </p>
              <ul className="space-y-4">
                {founder.values.map((value, index) => {
                  const [label, description] = value.split(':');
                  return (
                    <li key={index} className="flex items-start gap-3 text-zinc-600">
                      <div className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <span className="text-base">
                        <strong className="text-zinc-900">{label}</strong> {description}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

      {/* Stats Section - Light Grey */}
      <section className="py-16 bg-zinc-100 border-y border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white border border-zinc-200 p-8 text-center shadow-sm">
                <p className="text-4xl lg:text-5xl font-black text-orange-500 mb-2">{stat.number}</p>
                <p className="text-xs text-zinc-500 uppercase tracking-wider font-bold">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Heritage Section - White */}
      {/* <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="w-12 h-0.5 bg-orange-500" />
                <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">Background</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-black text-zinc-900 uppercase tracking-tight mb-6">
                Craftsmanship Runs Deep
              </h2>
              <p className="text-zinc-600 text-lg leading-relaxed mb-6">
                My father, Tony Farah, is an internationally recognized sculptor. Growing up, I learned that real craftsmanship isn't about taking shortcuts — it's about doing the work right, even when no one's watching.
              </p>
              <p className="text-zinc-600 text-lg leading-relaxed mb-6">
                That same mindset goes into every renovation we do. Whether it's leveling a subfloor or hanging drywall, the details matter. The work has to be solid.
              </p>
              <p className="text-zinc-500 text-base">
                From Lebanon to Halifax — different place, same standard.
              </p>
            </div>
            
            <div className="relative">
              <div className="aspect-square bg-zinc-100 border border-zinc-200 overflow-hidden shadow-lg">
                <img
                  src="/images/Angelo/Virgin_Mary.jpg"
                  alt="Construction work"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Service Area - Light Grey */}
      <section className="py-16 lg:py-24 bg-zinc-100 border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="aspect-video border border-zinc-300 overflow-hidden shadow-lg bg-white">
                <iframe
                  title="Halifax Map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d152697.6462973708!2d-63.62097029427679!3d44.67203640753733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sca!4v1769312531388!5m2!1sen!2sca"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
            
            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-12 h-0.5 bg-orange-500" />
                <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">Service Area</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-black text-zinc-900 uppercase tracking-tight mb-6">
                Halifax & HRM
              </h2>
              <p className="text-zinc-600 text-lg leading-relaxed mb-8">
                We serve homeowners throughout the Halifax Regional Municipality. From downtown to the suburbs — if you're in HRM, we've got you covered.
              </p>
              <div className="grid grid-cols-2 gap-4">
                {['Halifax', 'Dartmouth', 'Bedford', 'Sackville', 'Cole Harbour', 'Eastern Passage'].map((area) => (
                  <div key={area} className="flex items-center gap-3 text-zinc-700">
                    <span className="w-2 h-2 bg-orange-500" />
                    {area}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Dark */}
      <section className="py-16 lg:py-20 bg-zinc-900">
        <div className="max-w-4xl mx-auto px-4 lg:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-6">
            Let's Talk About Your Project
          </h2>
          <p className="text-zinc-400 mb-8 text-lg">
            No pressure, no sales pitch. Just an honest conversation about what you need.
          </p>
          <Link to="/contact">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white font-black uppercase tracking-wide px-8 py-6 text-base rounded-none">
              Contact Us
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;